import { CREATED_AT } from 'constants/templateList/TemplateListSortableFields';

export default {
  sort: `-${CREATED_AT}`,
  fields: {
    survey: `preview,name,id,description,created_at,updated_by,creator,updater,type_`,
  },
  include: 'creator,updater,preview',
};
